import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BASE_URL } from "@edl-development/edl-common";
import { CreatePresetDTO } from "../model/presets/create-preset-dto.model";
import { PresetDTO } from "../model/presets/preset-dto.model";
import { PaetepApi } from "./paetep/paetep.api";

@Injectable()
export class PresetManagementAPI extends PaetepApi {

    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    public getPresets(publishedOnly: boolean = false) {
        return this.http.get<PresetDTO[]>(this.baseUri + '/PresetManagement/GetAll/' + publishedOnly, {});
    }
    
    public getPreset(presetID: string) {
        return this.http.get<PresetDTO[]>(this.baseUri + '/PresetManagement/Get/' + presetID, {});
    }

    public createPreset(request: CreatePresetDTO) {
        return this.http.post<PresetDTO>(this.baseUri + '/PresetManagement/Create', request);
    }

    public deletePreset(presetID: string) {
        return this.http.delete(this.baseUri + '/PresetManagement/Delete/' + presetID);
    }

    public getPresetNames() {
        return this.http.get<string[]>(this.baseUri + '/PresetManagement/GetNames');
    }
}